// document.addEventListener("click", function(e) {
//   if (e.target.classList.contains("qty-minus") || e.target.classList.contains("qty-plus")) {
//     e.preventDefault(); 
//     const form = e.target.closest("form[data-product-id]");
//     if (!form) return;
//     const input = form.querySelector(".qty-input[name='quantity']");
//     if (!input) return;
//     let current = parseInt(input.value) || 1;
//     if (e.target.classList.contains("qty-minus") && current > 1) {
//       input.value = current - 1;
//     }
//     if (e.target.classList.contains("qty-plus")) {
//       input.value = current + 1;
//     }
//   }
// });

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('[data-products-to-show]').forEach(function(block) {
    const max = parseInt(block.dataset.productsToShow);
    const products = block.querySelectorAll('.product');
    products.forEach((p, i) => {
      if (i >= max) p.style.display = 'none';
    });
  });
});